var _g, _path, _path2, _path3, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1302_1849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 6C16 2.68629 18.6863 0 22 0H106C109.314 0 112 2.68629 112 6V122C112 125.314 109.314 128 106 128H22C18.6863 128 16 125.314 16 122V6Z",
    fill: "#FCFCFD"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 6C16 2.68629 18.6863 0 22 0H106C109.314 0 112 2.68629 112 6V122C112 125.314 109.314 128 106 128H22C18.6863 128 16 125.314 16 122V6Z",
    fill: "#FCFCFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8 6C16.8 3.12812 19.1281 0.8 22 0.8H106C108.872 0.8 111.2 3.12812 111.2 6V122C111.2 124.872 108.872 127.2 106 127.2H22C19.1281 127.2 16.8 124.872 16.8 122V6Z",
    stroke: "#EBECF0",
    strokeWidth: 1.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 128H106C109.314 128 112 125.314 112 122V118C112 121.314 109.314 124 106 124H22C18.6863 124 16 121.314 16 118V122C16 125.314 18.6863 128 22 128Z",
    fill: "#EBECF0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1302_1849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 64C64 61.3478 65.0536 58.8043 66.9289 56.9289C68.8043 55.0536 71.3478 54 74 54C76.6522 54 79.1957 55.0536 81.0711 56.9289C82.9464 58.8043 84 61.3478 84 64C84 66.6522 82.9464 69.1957 81.0711 71.0711C79.1957 72.9464 76.6522 74 74 74C71.3478 74 68.8043 72.9464 66.9289 71.0711C65.0536 69.1957 64 66.6522 64 64Z",
    fill: "#1ABCFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 84C44 81.3478 45.0536 78.8043 46.9289 76.9289C48.8043 75.0536 51.3478 74 54 74H64V84C64 86.6522 62.9464 89.1957 61.0711 91.0711C59.1957 92.9464 56.6522 94 54 94C51.3478 94 48.8043 92.9464 46.9289 91.0711C45.0536 89.1957 44 86.6522 44 84V84Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 34V54H74C76.6522 54 79.1957 52.9464 81.0711 51.0711C82.9464 49.1957 84 46.6522 84 44C84 41.3478 82.9464 38.8043 81.0711 36.9289C79.1957 35.0536 76.6522 34 74 34H64Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 44C44 46.6522 45.0536 49.1957 46.9289 51.0711C48.8043 52.9464 51.3478 54 54 54H64V34H54C51.3478 34 48.8043 35.0536 46.9289 36.9289C45.0536 38.8043 44 41.3478 44 44V44Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 64C44 66.6522 45.0536 69.1957 46.9289 71.0711C48.8043 72.9464 51.3478 74 54 74H64V54H54C51.3478 54 48.8043 55.0536 46.9289 56.9289C45.0536 58.8043 44 61.3478 44 64V64Z",
    fill: "#A259FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1302_1849",
    x: 16,
    y: 0,
    width: 96,
    height: 128,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1302_1849"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1302_1849"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 60,
    fill: "white",
    transform: "translate(44 34)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.2cf4c45e5a8c0fac07ac1004818e6c43.svg";
export { ForwardRef as ReactComponent };